export default __webpack_public_path__ + "static/media/Calendar.d78ca767.svg";